import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const documents = [
  {
    id: 'terms',
    title: 'Terms & Conditions',
    file: '/documents/terms.pdf',
  },
];

const Terms: React.FC = () => {
  return (
    <div className="container" style={{ maxWidth: '900px' }}>
      <h1>League Documents</h1>
      <p style={{ color: '#757575', marginBottom: '20px' }}>
        Please review the following documents. By registering, you agree to all terms outlined below.
      </p>

      {documents.map((doc) => (
        <div key={doc.id} className="card" style={{ marginBottom: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <h2 style={{ margin: 0 }}>{doc.title}</h2>
            <a
              href={doc.file}
              download
              className="btn btn-secondary"
              style={{ fontSize: '14px', padding: '8px 15px' }}
            >
              Download PDF
            </a>
          </div>
          <iframe
            src={doc.file}
            title={doc.title}
            style={{
              width: '100%',
              height: '600px',
              border: '1px solid #E0E0E0',
              borderRadius: '8px',
            }}
          />
        </div>
      ))}

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Link to="/register" className="btn btn-primary">
          Back to Registration
        </Link>
      </div>
    </div>
  );
};

export default Terms;
